import React, { useState, useEffect } from "react";
import notify from "devextreme/ui/notify";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  FilterRow,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";
import axiosApi from "../api-axios";
import DataSource from "devextreme/data/data_source";
import ShowError from "../AppServices";

const ConfigBox = () => {
  const [estado, setEstado] = useState([]);
  const configDs = new DataSource({
    store: {
      data: estado,
      type: "array",
      key: "campo",
    },
  });

  useEffect(() => {
    try {
      axiosApi
        .get(`/config/prefeitura/${UserInfo.getPrefeitura()}`)
        .then((response) => {
          if (response.data.data.length > 0) {
            setEstado([...response.data.data]);
          }
        });
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
      this.props.history.push("/");
    }
  }, []);

  async function updateConfig(e) {
    try {
      const formData = new FormData();
      e.data.prefeituraId = UserInfo.getPrefeitura();
      formData.set("campo", e.data.campo);
      formData.set("values", JSON.stringify(e.data));
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      await axiosApi.put(`config/`, formData, config);
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async function insertConfig(e) {
    try {
      const formData = new FormData();
      e.data.prefeituraId = UserInfo.getPrefeitura();
      formData.set("values", JSON.stringify(e.data));
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      await axiosApi.post(`config/`, formData, config);
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  return (
    <div className={"content-block dx-card responsive-paddings"}>
      <strong>
        <h3>Configurações</h3>
      </strong>
      <DataGrid
        dataSource={configDs}
        showBorders={true}
        rowAlternationEnabled={true}
        remoteOperations={true}
        focusedRowEnabled={true}
        wordWrapEnabled={true}
        onRowUpdated={(e) => updateConfig(e)}
        onRowInserted={(e) => insertConfig(e)}
      >
        <FilterRow visible={true} />
        <Editing
          mode={"row"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={false}
          useIcons={true}
        />
        <Column
          dataField={"campo"}
          caption={"Configuração"}
          width={275}
        />
        <Column
          dataField={"prefeituraId"}
          caption={"Prefeitura"}
          visible={false}
        ></Column>
        <Column dataField={"modulo"} caption={"Módulo"} />
        <Column
          dataField={"descricao"}
          caption={"Descrição"}
        />
        <Column dataField={"valorStr"} caption={"Valor Texto"} />
        <Column dataField={"valorInt"} caption={"Valor Inteiro"} />
        <Column dataField={"valorDecimal"} caption={"Valor Decimal"} />
        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
        />
      </DataGrid>
    </div>
  );
};

export default ConfigBox;
